import { Stack } from '@kvdbil/components';
import styled from 'styled-components';

export const GeneralRulesMessagesWrapper = styled(Stack)`
  margin-bottom: 1rem;
  padding: 0.5rem 0.25rem;
  width: 100%;
`;
